/**
 * Helper functions for aggregator error handling
 * Provides consistent error messages across aggregator views
 */

import { AGGREGATOR_ERROR_MESSAGES } from './aggregator.constants';

export type AggregatorErrorContext = 'disclosures' | 'status';

/**
 * Gets a user-friendly error message based on error and context
 */
export const getAggregatorErrorMessage = (error: any, context: AggregatorErrorContext): string => {
  const statusCode = error?.statusCode;

  if (statusCode === 401) {
    return AGGREGATOR_ERROR_MESSAGES.TOKEN_EXPIRED;
  }

  if (statusCode === 404) {
    if (context === 'disclosures') {
      return AGGREGATOR_ERROR_MESSAGES.DISCLOSURES_NOT_FOUND;
    }
    return AGGREGATOR_ERROR_MESSAGES.NOT_FOUND;
  }

  return AGGREGATOR_ERROR_MESSAGES.GENERIC_ERROR;
};
